import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router, CanActivate } from '@angular/router';
import { Observable } from 'rxjs';
import { EnvService } from 'src/app/env.service';
import { AuthenticationService } from '../services/authentication.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(private router: Router, private authenticationService: AuthenticationService, private envService: EnvService) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    const currentToken = this.authenticationService.currentToken;

    if (currentToken) {
      try {
        const tokenData = JSON.parse(atob(currentToken.split('.')[1]));

        if (tokenData.exp * 1000 < Date.now()) {
          this.authenticationService.logout();
          localStorage.setItem('sessionExpired', 'true');
          location.reload();
          return false;
        }
      } catch (error) {
        console.error(error);
        this.authenticationService.logout();
        localStorage.setItem('sessionExpired', 'true');
        location.reload();
        return false;
      }

      if (state.url === '/') {
        this.router.navigate(['/app']);
        return false;
      }

      // authorized so return true
      return true;
    }

    this.router.navigate(['/login']);

    // Questo perché quando scade la sessione verrebbe impostato un return url su /app/unauthorized
    // e si verrebbe reindirizzati erroneamente alla pagina di unauthorized
    // if (state.url.includes('/app/unauthorized')) { // Aggiungere qui in OR i return url che vogliamo escludere dal reindirizzamento
    //   //this.router.navigate(['/login']);
    // } else if (!state.url.includes('/login')) {
    //   // not logged in so redirect to login page with the return url
    //   console.log('here')
    //   this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
    // }
    return false;
  }
}
